import { render, staticRenderFns } from "./FfDemoView.vue?vue&type=template&id=096c6ebe&scoped=true&"
import script from "./FfDemoView.vue?vue&type=script&lang=js&"
export * from "./FfDemoView.vue?vue&type=script&lang=js&"
import style0 from "./FfDemoView.vue?vue&type=style&index=0&id=096c6ebe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096c6ebe",
  null
  
)

export default component.exports